module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/fin/journals/journals-show/journals-show.component.scss
// module id = ./src/app/views/fin/journals/journals-show/journals-show.component.scss
// module chunks = main